/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { UseAccounts } from '../../../hooks/accounts/useAccounts';

function AccountsCard({ cardName, history, btnName, image }) {
  const [{ accounts, isLoading }] = UseAccounts();

  return (
    <div className="col-md-12 col-12 pb-4">
      <p className="ml-4">{cardName}</p>
      <div className="col-12 mb-4">
        {isLoading ? (
          <div className="card box shadow h-100 mb-2 py-2">
            <div className="card-body">
              <small>loading...</small>
            </div>
          </div>
        ) : (
          accounts.map((account) => (
            <div
              key={account.username}
              className="card box shadow h-100 mb-2 py-2"
            >
              <div>
                {btnName === 'Renew' ? (
                  <button
                    type="button"
                    className="btn btn-success float-right up_btn"
                    style={{ backgroundColor: '#4CD32A', border: '#4CD32A' }}
                    onClick={() => history.push('/subscribe')}
                  >
                    {btnName}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-info float-right up_btn"
                    // onClick={}
                  >
                    {btnName}
                  </button>
                )}
              </div>
              <div className="card-body">
                <div className="row col-auto align-items-center">
                  <div className="col-auto mr-2">
                    <div className="d-flex mb-2">
                      <div>
                        <img src={image} alt="House" className="mr-3" />
                      </div>
                      <div className="mb-3">
                        <p className="font_22 text-wrap letter_spacing margin_bottom">
                          {account.name}
                        </p>
                        <p className="font_16 lighter_font rubik">
                          {btnName === 'Renew' ? (
                            account.value
                          ) : (
                            <>
                              Account Number:
                              {` `}
                              {account.customer_ref}
                            </>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

AccountsCard.propTypes = {
  cardName: PropTypes.string.isRequired,
  btnName: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  history: PropTypes.shape().isRequired,
  accounts: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default withRouter(AccountsCard);
